"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const NAMESPACE = "new-3d-printing";

const IMAGE_BASE = "/image/new-version/more/3D-Printing/Quality-System";

const IMAGES = [
	{
		src: `${IMAGE_BASE}/efficient-reliable-3d-printing-quality-system-1.webp`,
		altKey: "qualitySystemImageAlt1",
	},
	{
		src: `${IMAGE_BASE}/efficient-reliable-3d-printing-quality-system-2.jpg`,
		altKey: "qualitySystemImageAlt2",
	},
	{
		src: `${IMAGE_BASE}/efficient-reliable-3d-printing-quality-system-3.webp`,
		altKey: "qualitySystemImageAlt3",
	},
	{
		src: `${IMAGE_BASE}/efficient-reliable-3d-printing-quality-system-4.webp`,
		altKey: "qualitySystemImageAlt4",
	},
] as const;

const FEATURES = ["qualitySystemFeature1", "qualitySystemFeature2", "qualitySystemFeature3"] as const;

export default function QualitySystem() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#fcfff4] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("qualitySystemTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("qualitySystemDesc")}</p>
				</header>

				<div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-12">
					<div className="grid grid-cols-2 gap-3 sm:gap-4">
						{IMAGES.map((image) => (
							<div key={image.altKey} className="relative aspect-[4/3] w-full overflow-hidden bg-[#f5f7fa]">
								<Image
									src={image.src}
									alt={t(image.altKey)}
									fill
									className="object-cover"
									sizes="(max-width: 1024px) 50vw, 25vw"
								/>
							</div>
						))}
					</div>

					<div className="flex flex-col gap-5 sm:gap-6 md:gap-7">
						{FEATURES.map((prefix) => (
							<div key={prefix}>
								<h3 className="mb-2 text-base font-bold text-themePrimary400 sm:mb-3 sm:text-lg md:text-xl">
									{t(`${prefix}Title`)}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">{t(`${prefix}Desc`)}</p>
							</div>
						))}

						<div>
							<Link
								href="/quality-assurance"
								className="inline-flex items-center gap-2 text-sm font-semibold text-themePrimary400 transition-colors duration-300 hover:text-[#83b751] md:text-base"
							>
								<span>{t("qualitySystemLearnMore")}</span>
								<span aria-hidden="true">→</span>
							</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
